export default __webpack_public_path__ + "static/media/next.297a3f9e.svg";